/* app defaults 
 *    Date - override to string
 *    Kendo - default RO
 */

function isInvalidDate(date) {
    return !date || !(date instanceof Date) || isNaN(date.getDate());
}

Date.prototype.toString = function dateToString() {
    let date = this;
    if (isInvalidDate(date)) return "";

    let year = date.getFullYear();
    let month = ('0' + (date.getMonth() + 1)).slice(-2);
    let day = ('0' + date.getDate()).slice(-2);

    let hours = ('0' + date.getHours()).slice(-2);
    let minutes = ('0' + date.getMinutes()).slice(-2);
    let seconds = ('0' + date.getSeconds()).slice(-2);

    return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
};

Date.prototype.toTimeString = function toTimeString(template) {
    let date = this;
    if (isInvalidDate(date)) return "";

    let hours = ('0' + date.getHours()).slice(-2);
    let minutes = ('0' + date.getMinutes()).slice(-2);
    let seconds = ('0' + date.getSeconds()).slice(-2);

    if (template === 'HH:mm:ss') return `${hours}:${minutes}:${seconds}`;

    return `${hours}:${minutes}`;
};

Date.prototype.convertToDate = function convertToDate() {
    let date = new Date(this);
    if (isInvalidDate(date)) null;

    date.setHours(0, 0, 0, 0);

    return date;
};

Date.prototype.toDateString = function dateToString(template) {
    let date = this;
    if (isInvalidDate(date)) return "";

    let year = date.getFullYear();
    let month = ('0' + (date.getMonth() + 1)).slice(-2);
    let day = ('0' + date.getDate()).slice(-2);

    if (template === 'yyyy/MM') return `${year}/${month}`;
    else if (template === 'yyyy') return `${year}`;
    return `${year}-${month}-${day}`;
};

Date.prototype.toRoDateString = function toRoDateString(shortYear) {
    let date = this;
    if (isInvalidDate(date)) return "";

    let year = '' + date.getFullYear();
    let month = ('0' + (date.getMonth() + 1)).slice(-2);
    let day = ('0' + date.getDate()).slice(-2);

    if (shortYear) {
        year = year.slice(-2)
    }

    return `${day}.${month}.${year}`;
};

Date.prototype.toDateAbbrString = function toDateAbbrString(separator = ".", longFormat, template) {
    let date = this;
    if (isInvalidDate(date)) return "";

    let namesAbbr = ["ian", "feb", "mar", "apr", "mai", "iun", "iul", "aug", "sept", "oct", "nov", "dec"];

    if (longFormat === true) {
        namesAbbr = ["Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie", "Iulie", "August", "Septembrie", "Octombrie", "Noiembrie", "Decembrie"];
    }

    let year = date.getFullYear();
    let month = date.getMonth();
    let day = ('0' + date.getDate()).slice(-2);
    let dayName = date.getDayName();

    if (template == "dd/MM") {
        return `${day}${separator}${namesAbbr[month]}`;
    }

    if (template == "day,dd/MM") {
        return `${dayName}, ${day}${separator}${namesAbbr[month].toLowerCase()}`;
    }

    if (template == "day,dd/MM/yyyy") {
        return `${dayName}, ${day}${separator}${namesAbbr[month].toLowerCase()}${separator}${year}`;
    }

    return `${day}${separator}${namesAbbr[month]}${separator}${year}`;
};

Date.prototype.getDayName = function getDayName() {
    let date = this;
    if (isInvalidDate(date)) return "";

    const weekday = ["Duminica", "Luni", "Marti", "Miercuri", "Joi", "Vineri", "Sambata"];

    return weekday[date.getDay()];
};

String.prototype.toDate = function toDate(onlyDate) {
    if (onlyDate) {
        return (new Date(this)).convertToDate();
    }

    return new Date(this);
};

String.prototype.indexOfInsensitive = function (s, b) {
    return this?.toLowerCase()?.indexOf(s?.toLowerCase(), b);
};
